import { get } from 'lodash';
import { connect } from 'react-redux';

import SustainabilityPage from 'components/SustainabilityPage';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';

const mapStateToProps = (state, ownProps) => {
  const { data, modalSettings, reportLink } = ownProps;
  const pageSlides = get(data, 'pageSlides', []);
  const emailSignupModule = get(data, 'emailSignupModule', {});

  const isModalOpen = get(state, ['app', 'modal']) === MODAL_TYPES.SUSTAINABILITY_PAGE;

  return {
    pageSlides,
    isModalOpen,
    modalSettings,
    emailSignupModule,
    reportLink,
    ...data,
  };
};

const mapDispatchToProps = dispatch => ({
  trackEvent: ({ eventAction, eventLabel, eventValue }) =>
    dispatch(actions.trackSustainabilityPageEvent({ eventAction, eventLabel, eventValue })),
  openModal: () => dispatch(actions.openSustainabilityPageModal()),
  closeModal: () => dispatch(actions.closeModal()),
  signUpForNewsletter: params => dispatch(actions.signUpForNewsletter(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SustainabilityPage);
